//周期表化合物列表
export const API_LIBRARY_LIST = `/admin/lasp/library/list`
export const API_LIBRARY_Info = `/admin/lasp/library/info`
//文件上传
export const API_COMM_UPLOAD = `/admin/comm/upload`
//登录注册
export const API_COMM_LOGIN = `/admin/sys/user/login`
export const API_COMM_REGISTER = `/admin/sys/user/register`
export const API_COMM_RESET = `/admin/sys/user/reset`
//文件地址
export const API_FILE_Info = `/admin/lasp/file/info`
//记录免费用户下载
export const API_FILE_RECORD = `/admin/lasp/downloadhistory/record`
//计算
export const API_CALCULATE = `/admin/lasp/calculate`
//增加实验组
export const API_USERDOWNLOAD_ADD = `/admin/lasp/userdownload/add`



// WEBPACK FOOTER //
// ./src/constant/api.js